import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import Medium from "./TicketMedium.woff2";

export const TicketMediumFontFaces: ExcalidrawFontFaceDescriptor[] = [
  // Thin  ExtraLight  Light  Regular  Medium  SemiBold  Bold  ExtraBold
  { uri: Medium },
];
